'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LandingPageDisplayRecord = require('../records/LandingPageDisplayRecord');

var _LandingPageDisplayRecord2 = _interopRequireDefault(_LandingPageDisplayRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RECORD = new _LandingPageDisplayRecord2.default({});

var LandingPageDisplayContainer = {
  get: function get() {
    return RECORD;
  },
  set: function set() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    RECORD = new _LandingPageDisplayRecord2.default(opts);
  }
};

exports.default = LandingPageDisplayContainer;
module.exports = exports['default'];